var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function AlertErrorCircleIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17ZM11 7.50293C11 6.94903 11.4439 6.5 12 6.5C12.5523 6.5 13 6.94853 13 7.50293V12.4971C13 13.051 12.5561 13.5 12 13.5C11.4477 13.5 11 13.0515 11 12.4971V7.50293Z", fill: "" })));
}
export var AlertErrorCircleIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: AlertErrorCircleIconInner }, props))); };
//# sourceMappingURL=AlertErrorCircleIcon.js.map